"use client";
// Imports

// Icon
export function MapIcon({ icon, size = 32, active = false }) {
  switch (icon) {
    case "default":
      return <DefaultIcon size={size} active={active} />;

    // Attractions
    // case "aggies-farm":
    //   return null;

    // case "animal":
    //   return null;

    // case "attractions":
    //   return null;

    // case "bar":
    //   return null;

    // case "carnival":
    //   return null;

    // case "celler-door":
    //   return null;

    // case "competition":
    //   return null;

    // case "dining":
    //   return null;

    // case "education":
    //   return null;

    // case "kids-carnival":
    //   return null;

    // case "lifestyle":
    //   return null;

    // case "live-entertainment":
    //   return null;

    // case "shopping":
    //   return null;

    // Facilities
    default:
      return <DefaultIcon size={size} active={active} />;
  }
}

function DefaultIcon({ size, active }) {
  return (
    <svg
      width="53"
      height="52"
      viewBox="0 0 53 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_3_14)">
        <path
          d="M41.1995 13.07C38.7606 10.456 32.581 12.2565 27.3997 17.0906C19.2671 24.6784 10.8726 41.3651 10.8726 41.3651C10.8726 41.3651 28.1004 34.1461 36.2331 26.5583C41.4159 21.7258 43.6399 15.6856 41.1995 13.07Z"
          fill="black"
          fillOpacity="0.5"
        />
      </g>
      <path
        d="M13.4006 0.771759C6.4234 0.771759 0.765137 6.43002 0.765137 13.4072C0.765137 24.3588 13.4006 41.6106 13.4006 41.6106C13.4006 41.6106 26.0361 24.3588 26.0361 13.4072C26.0405 6.43002 20.3822 0.771759 13.4006 0.771759Z"
        fill={active ? "#FC652E" : "#892102"}
      />
      <path
        d="M25.5361 13.4069V13.4072C25.5361 16.0589 24.7689 19.126 23.5936 22.2586C22.4206 25.3851 20.8535 28.5449 19.2813 31.3728C17.7098 34.1995 16.1376 36.6869 14.958 38.4678C14.3684 39.358 13.8773 40.071 13.534 40.561C13.4867 40.6286 13.4422 40.6919 13.4006 40.7508C13.359 40.6919 13.3145 40.6286 13.2672 40.561C12.9239 40.071 12.4328 39.358 11.8432 38.4678C10.6636 36.6869 9.0914 34.1995 7.51987 31.3728C5.94767 28.5449 4.38055 25.3851 3.20757 22.2586C2.0323 19.126 1.26514 16.0589 1.26514 13.4072C1.26514 6.70616 6.69954 1.27176 13.4006 1.27176C20.1062 1.27176 25.5403 6.70626 25.5361 13.4069Z"
        stroke="white"
      />
      <path
        d="M23.1021 13.4395C23.1021 18.7058 18.8329 22.9749 13.5667 22.9749C8.30042 22.9749 4.03129 18.7058 4.03129 13.4395C4.03129 8.17327 8.30042 3.90413 13.5667 3.90413C18.8329 3.90413 23.1021 8.17327 23.1021 13.4395Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_3_14"
          x="0.872643"
          y="1.87053"
          width="51.3174"
          height="49.4946"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_3_14"
          />
        </filter>
      </defs>
    </svg>
  );
}
